import React from "react";

/**
 * Extracts a YouTube video ID from common URL formats.
 * Supports: youtu.be/ID, youtube.com/watch?v=ID, youtube.com/embed/ID, youtube.com/shorts/ID
 */
function extractYouTubeId(url) {
  if (!url) return null;
  try {
    const u = new URL(url);
    if (u.hostname.includes("youtu.be")) return u.pathname.slice(1).split("/")[0];
    if (u.searchParams.get("v")) return u.searchParams.get("v");
    const parts = u.pathname.split("/").filter(Boolean);
    const idx = parts.findIndex((p) => p === "embed" || p === "shorts" || p === "v");
    if (idx >= 0 && parts[idx + 1]) return parts[idx + 1];
    return null;
  } catch {
    return null;
  }
}

export default function VideoPlayer({ url, title }) {
  if (!url) return null;
  const id = extractYouTubeId(url);
  if (!id) {
    return (
      <div className="aspect-video w-full bg-[#F5F2EB] rounded-2xl border border-[#EAE5D9] flex items-center justify-center text-[#8A857D]">
        Unsupported video URL.
      </div>
    );
  }
  return (
    <div className="aspect-video w-full rounded-2xl overflow-hidden border border-[#EAE5D9] shadow-[0_8px_30px_rgba(0,0,0,0.06)] bg-black" data-testid="lesson-video-player">
      <iframe
        className="w-full h-full"
        src={`https://www.youtube.com/embed/${id}?rel=0&modestbranding=1`}
        title={title || "Lesson video"}
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowFullScreen
      />
    </div>
  );
}
